import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Trip } from 'src/app/shared/classes/trip';
import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { ITripPreference } from 'src/app/core/types/interfaces/trip-elements.interface';

import { TripWizardStateService } from 'src/app/shared/components/trip-wizard/trip-wizard-state.service';

import { TripSliderComponent } from './trip-slider/trip-slider.component';

@Component({
  selector: 'app-trip-preferences',
  templateUrl: './trip-preferences.component.html',
  styleUrls: ['./trip-preferences.component.scss'],
  imports: [TripSliderComponent, MatRipple, MatIcon],
})
export class TripPreferencesComponent {
  @Input() showTripPreferences: boolean = true;
  @Output() sliderEvent: EventEmitter<[]> = new EventEmitter();
  @Output() buttonEvent: EventEmitter<boolean> = new EventEmitter();

  preferenceSliders: ITripPreference[] = [];
  eSvgIcons = ESvgIcons;

  private trip: WritableSignal<Trip>;

  #tripWizardStateService: TripWizardStateService = inject(
    TripWizardStateService,
  );

  constructor() {
    this.#tripWizardStateService.currentTripState
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.trip = signal(this.#tripWizardStateService.currentTripStateValue);
        const { scores } = this.trip();
        const preferences = [];
        for (const key in scores) {
          preferences.push(scores[key]);
        }
        this.preferenceSliders = preferences;
      });
  }

  public updateSlider(preference: ITripPreference): void {
    const { scores } = this.trip();
    scores[preference.ref].value = preference.value;
    this.trip.update((trip) =>
      trip.updateTrip({
        isOptimizedMode: true,
        scores: scores,
      }),
    );
    this.updateTripState();
    this.sliderEvent.emit();
  }

  private updateTripState(): void {
    this.#tripWizardStateService.currentTripState = new Trip({
      ...this.trip(),
    });
  }
}
